import React from 'react';

type Props = {
  refreshing: boolean;
  isReady: boolean;
};

export const PullToRefreshIndicator: React.FC<Props> = ({ refreshing, isReady }) => {
  return (
    <div className="h-12 -mt-12 flex items-center justify-center select-none bg-brand/5 text-brand font-bold">
      {refreshing ? (
        <span className="flex items-center gap-2">
          <svg
            className="animate-spin h-5 w-5"
            viewBox="0 0 24 24"
            style={{ animationDuration: '0.8s' }}  // より速く滑らかな回転
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
              fill="none"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          更新中…
        </span>
      ) : isReady ? (
        <span className="animate-pulse">✨ 離すと更新</span>
      ) : (
        <span>↓ 引いて更新</span>
      )}
    </div>
  );
};